(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('HeaderBidisoController', ["$window", HeaderBidisoController]);

    /* @ngInject */
    function HeaderBidisoController($window) {
        var vm = this;

        vm.openNav =  function () {
            $window.document.getElementById("mySidenav").style.width = "350px";
        };
        vm.closeNav = function () {
            $window.document.getElementById("mySidenav").style.width = "0";
        };
    }

})(angular);
